import Swiper, { Navigation, Autoplay } from 'swiper';

import 'swiper/css/bundle';

const swiper = new Swiper('.cards-slider', {
    modules: [Navigation, Autoplay],
    loop: false,
    speed: 1000,
    slidesPerView: 1,
    spaceBetween: 32,

    // autoplay: {
    //     delay: 3500,
    //     disableOnInteraction: false,
    //     pauseOnMouseEnter: true,
    // },

    breakpoints: {
        1024: {
            slidesPerView: 3,
        },
        1400: {
            slidesOffsetBefore: 554,
                   slidesPerView: 3,
        },
    },

    navigation: {
        nextEl: '.crd-swiper-next-btn',
        prevEl: '.crd-swiper-prev-btn',
    },
});
